import React from "react";
import { useTranslation } from "react-i18next";
import LandingHeader from "../components/Landing/sections/LandingHeader.jsx";
import LandingNav from "../components/Landing/sections/LandingNav.jsx";
import LandingFooter from "../components/Landing/sections/LandingFooter.jsx";
import "../styles/new-landing.css";

import { useEffect } from "react";
import useRestoreScroll from "../hooks/useRestoreScroll.js";

const About = () => {
  const { t } = useTranslation();
  useRestoreScroll();

  useEffect(() => {
    document.body.style.overflow = "";
    document.body.style.overflowY = "";
    return () => {
      document.body.style.overflow = "";
      document.body.style.overflowY = "";
    };
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <LandingHeader />
      <LandingNav />
      <div className="landing-info-page">
        <div className="landing-info-hero">
          <h1>{t('about.header.title')}</h1>
          <p>{t('about.header.subtitle')}</p>
        </div>

        <div className="landing-info-grid two" style={{ marginBottom: '56px' }}>
          <div className="landing-info-card">
            <div className="landing-info-card-icon" style={{ background: '#f3e8ff', color: '#7c3aed' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                <path d="M12 7a5 5 0 0 1 0 10a5 5 0 0 1 0-10z" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </div>
            <h3>{t('about.cards.vision.title')}</h3>
            <p>{t('about.cards.vision.description')}</p>
          </div>
          <div className="landing-info-card">
            <div className="landing-info-card-icon" style={{ background: '#ffedd5', color: '#f97316' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </div>
            <h3>{t('about.cards.mission.title')}</h3>
            <p>{t('about.cards.mission.description')}</p>
          </div>
        </div>

        <div className="landing-info-split" style={{ marginBottom: '56px' }}>
          <div>
            <h2>{t('about.story.title')}</h2>
            <h3>{t('about.story.subtitle')}</h3>
            <p style={{ color: 'var(--text-muted)', lineHeight: 1.7 }}>{t('about.story.paragraph1')}</p>
            <p style={{ color: 'var(--text-muted)', lineHeight: 1.7 }}>{t('about.story.paragraph2')}</p>
            <p style={{ color: 'var(--text-muted)', lineHeight: 1.7 }}>{t('about.story.paragraph3')}</p>
          </div>
          <img src="/images/Sulhafa-Main.png" alt="Sulhafa Turtle Mascot" />
        </div>

        <div className="landing-info-section">
          <h2 className="landing-info-section-title">{t('about.framework.title')}</h2>
          <p className="landing-info-text" style={{ marginBottom: '32px' }}>{t('about.framework.description')}</p>
          <div className="landing-info-grid three">
            <div className="landing-info-card">
              <div className="landing-info-card-icon" style={{ background: '#f3e8ff', color: '#8E44AC' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke="currentColor" strokeWidth="2"/>
                  <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" stroke="currentColor" strokeWidth="2"/>
                </svg>
              </div>
              <h3>{t('about.framework.curriculum.title')}</h3>
              <p>{t('about.framework.curriculum.description')}</p>
            </div>
            <div className="landing-info-card">
              <div className="landing-info-card-icon" style={{ background: '#dbeafe', color: '#2a8ad2' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
                </svg>
              </div>
              <h3>{t('about.framework.coaching.title')}</h3>
              <p>{t('about.framework.coaching.description')}</p>
            </div>
            <div className="landing-info-card">
              <div className="landing-info-card-icon" style={{ background: '#ffedd5', color: '#f97316' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
                  <path d="M12 3v2M12 19v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M3 12h2M19 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" stroke="currentColor" strokeWidth="2"/>
                </svg>
              </div>
              <h3>{t('about.framework.community.title')}</h3>
              <p>{t('about.framework.community.description')}</p>
            </div>
          </div>
        </div>

        <div className="landing-info-cta">
          <h2>{t('about.purpose.title')}</h2>
          <h3 style={{ fontSize: '18px', fontWeight: 600, color: 'var(--text-dark)', marginBottom: '16px' }}>{t('about.purpose.subtitle')}</h3>
          <p>{t('about.purpose.conclusion')}</p>
          <p style={{ fontWeight: 700, color: 'var(--purple)' }}>{t('about.purpose.promise')}</p>
        </div>
      </div>
      <LandingFooter />
    </>
  );
};

export default About;
